import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0067',
    ecrans: ['00-2']
});
